import React, { useEffect, useRef, useState } from 'react';
import { Globe, ChevronDown } from 'lucide-react';
import { SUPPORTED_LANGS, useLanguage } from '../contexts/LanguageContext';

const labelMap = {
  en: 'English',
  'zh-Hant': '繁中',
  'zh-CN': '简中',
};

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    const onClickOutside = (event) => {
      if (!rootRef.current?.contains(event.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  return (
    <div ref={rootRef} className="relative">
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        className="inline-flex items-center gap-2 rounded-lg border border-slate-200/80 bg-white/85 px-3 py-1.5 text-sm font-semibold text-slate-700 shadow-sm backdrop-blur hover:bg-white"
      >
        <Globe className="h-4 w-4" />
        <span>{labelMap[language] || language}</span>
        <ChevronDown className={`h-4 w-4 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="absolute right-0 z-50 mt-2 w-40 overflow-hidden rounded-lg border border-slate-200 bg-white shadow-lg">
          {SUPPORTED_LANGS.map((lang) => (
            <button
              type="button"
              key={lang}
              onClick={() => {
                setLanguage(lang);
                setOpen(false);
              }}
              className={`block w-full px-3 py-2 text-left text-sm hover:bg-slate-50 ${
                language === lang ? 'bg-blue-50 font-semibold text-blue-700' : 'text-slate-700'
              }`}
            >
              {labelMap[lang]}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
